<template>
  <div class="form-row">
    <ElFormItem prop="project_name" class="full-width">
      <AppInput
        v-model="store.formData.project_name"
        label="Project name"
        placeholder="Downtown plaza stormwater report"
        :required="true"
        autofocus
      />
    </ElFormItem>
  </div>
  <div class="form-row">
    <ElFormItem prop="project_location" class="full-width">
      <MapboxAddressInput ref="mapboxInput" />
    </ElFormItem>
  </div>

  <!-- Site Data Fields -->
  <div class="form-row">
    <ElFormItem prop="site_area" class="full-width">
      <div class="mb-20px">
        <AppLabel for="site_area" content="Total site area (m2)" class="mb-10px" required />
        <p class="font-14px text-muted f--1">
          Auto-calculated from the property boundary. You can correct this value if needed.
        </p>
      </div>
      <AppInput v-model="store.formData.site_area" type="number" placeholder="1000" :required="true" />
    </ElFormItem>
  </div>

  <div class="form-row">
    <ElFormItem prop="land_use_type" class="full-width">
      <AppSelect
        v-model="store.formData.land_use_type"
        label="Land use type"
        :options="landUseOptions"
        placeholder="Select land use type"
        size="large"
        :required="true"
      />
    </ElFormItem>
  </div>

  <div class="form-row">
    <ElFormItem prop="soil_type" class="full-width">
      <AppSelect
        v-model="store.formData.soil_type"
        label="Soil type"
        :options="soilTypeOptions"
        placeholder="Select soil type"
        size="large"
      />
    </ElFormItem>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { ElFormItem } from "element-plus";
import { AppInput, AppLabel, AppSelect } from "@/components/ui";
import MapboxAddressInput from "@/views/NewReportView/components/MapboxAddressInput.vue";
import { landUseOptions, soilTypeOptions } from "@/utilities/collections/newReportOptions";
import { useReportFormStore } from "@/stores/reportFormStore";

const store = useReportFormStore();

const mapboxInput = ref(null);

defineExpose({ mapboxInput });
</script>
